<template>
  <!--  Section "My Provide Services" -->
  <section id="services">
    <div class="services container">
      <div class="service-top">
        <h3>My Provide Services</h3>
      </div>
      <div class="service-bottom">
        <b-container class="bv-example-row">
          <div class="row kind-container">
            <b-col
              v-for="(card, i) in cards"
              :key="i"
              sm="12"
              md="6"
              lg="6"
              xl="4"
              class="service-col"
            >
              <b-card>
                <img :src="`${card.icon}`" alt="img" class="service-logo" />
                <h5>{{ card.title }}</h5>
                <b-card-text>
                  There are many variations of passages of Lorem Ipsum
                  available, but the majority have suffered alteration.
                </b-card-text>
              </b-card>
            </b-col>
          </div>
        </b-container>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServiceSection",
  data() {
    return {
      cards: [
        {
          icon: "https://previews.dropbox.com/p/thumb/ABqDPDL9UbIf4v_7ddJDPU09K9xRsaws9ZNw4GrKIYjDQ00qbhYzlWXJ7ubsPgW79eVPhQ7CciTpfYFgQefbYfvlrGDt7qBRaDSU-rixe5yzHU1SWVslEeeCJ8jnMd-39ZHTnXohzx3ftJ_VbTJM83tNry14KZ0eaC4_JO1p3sr_RrUcaLEcVekejzzBSkcEUltORSrSMmIBRNKFEvrpxqhNt4Id3DPfZfxi_W_vvmSMusAdBtIuNk8SeCCeVTZhKBQs-b0VxQxSA82av-9_NgfFuBZRCk7fQHQleuAtb9J9bzZuznVJe8cfvfs8DWMG58U1ZGHRhQhs0MGD-0WdQkE3Irf59xr7hFqjBiEwW5cQdFA7TecIcLoaTDZTDYgz-GE/p.png",
          title: "Graphic Design",
        },
        {
          icon: "https://previews.dropbox.com/p/thumb/ABp7dIHCmk2QyACFHIuYIIy4dduAFihJ3HBawqt20EzjP5EoiS2tMawz-hIAggFWBUcENBFgodSGOP83Slji8tkpjPkGRtFDlua9H4MAQOakJsUdicfO-xe7uO9UATkkU5sgqT5Gn-Yg-SYaG1jUoTnbi-bV7ofWog_BKv89lfSmJtpuAksXY1mcjLvZyIecCqUDFjT1amXYv-LDVg3MHmQlJN2__fua1q9oq9INiWNMBtgmDLYBTyDsieFBiUsFpX1R2lMTjL0YSIyVy2PALf_JuWpKrosjMMTn0OSA5KOmL2Yu0XVqW7z0I4gkahMaF_qrV4mWA7R1NFAg93YXYnlG5xiHqkfkfhk1TgTVK95UrAbBQJE2Wz6EfubJ6cqaIAQ/p.png",
          title: "SEO Marketing",
        },
        {
          icon: "https://previews.dropbox.com/p/thumb/ABqFxHJzvtQZVsNYN37VBtR9kXODPNB4T8lwCn8uH-ddtrMO3CHwSsgOZeeso_mxhu81KxrH9qkoq9s56Hexj0n3zU6s9VKdZQJMWBzdhQjqHFwgDxWomZiMphitpZ_LTLTvQWuInLyYo4T70-pnfQXQPSgvUTgCNzAWXljiKre28yDqa0Us8-nHDCBjK-muwdmfeIcalshCHNUj8GUHbKRkcXmt_lIbHKt1qz2M2DXF2IJvC5WdXUnavovCvWEypK8VKSCuDCvU7KlZKDFwDiQI80CRqbpMWhJGGfRu6IFyUeXXaMltrQUAdDf1ySPBHizmZLAr0MUaCNs6aAl9k1hNQtPwkPipt-q_88ZJWjermhBgL-esAR8RQZ5DkXHAPb4/p.png",
          title: "Data Analysis",
        },
        {
          icon: "https://previews.dropbox.com/p/thumb/ABryB7n4l51Z1iZP7wU00EVYJBe3eVByI_8TayymGKSUM79ScycB5OQmmIbK8sQuCWkF7W_hdC-r7s65eCvrGCCD-93wFa_yWiNve5TyGDpZmz8-yHYmR6FJgnDA7qPGCYUCSYmRa0L1YIGIfwy5dpbHXJwzzUhoc4P0vGO0TCs7V5SM3NlsUcnsnJv9oAbLwtbtuCHmO2QhvAPuA5kZPziusVSZLeaBn_ekgtTPvP-8RL9kGUugwLIu68JUSJBudCak0zMRvGkg0I9s_5sf4u_dPT69DqvTO1efNv0RX4ceyoHi8FOfBlND67_KYt19VsnVbP5NBsBxVcxlnU0VmBf2rYDB5Qz2P-QfaipgxZUdq2xjTTidY8ueV8xZdCkj11k/p.png",
          title: "Digital Marketing",
        },
        {
          icon: "https://previews.dropbox.com/p/thumb/ABpZyeLSBfYYJrjE6yH1KzashfOrNEm6veN68RR8Ukt1FWVoT8L1YPalaEnwdawDJMo_yK4eIuvb6q1KiSopFFalmKCpSuTYWPnAP2v0LLBSHE_zQoWSzF9F6RkGu3U8FRSDQfdjXE-4eQc3LmoLrOfkI8P0zorSRV1Zwk2UdF9E_IISRzmB0QM3FawhnNHt8mGvg14EzAR8kOibDRj-32YebX_vXYMnp6s0LhlozbVEN2B-fEmCZvmjt6rl7Gg20n7cYZfgWa4043vcqVD120vVQw4x_9Gbhj0-43uf5HA6flBK7CA1R1Q5bsBCsVdYBE1ZSa_VlrC12byUtuurrJhkz-vsjL4I95ItttY7XmehjUu0HLYZVLXCrkknz43nvBs/p.png",
          title: "Video Editing",
        },
        {
          icon: "https://previews.dropbox.com/p/thumb/ABqnmlUQsVqeDvEq6m_9xtDFjYxTeJPdnwuPYyC7fLokeGhUWZ0QN25_P7vig6bCNCDWToERBC8eiS0olS6IYjr23riKxN3FFVZeHY3Uef4ewdpY60L3acatXDknFf3ZUnrsT-BAlNTtI2Zf0Av85XkLs1jRoksyKdZ-8CllzERU0vgqZYj_6Uc93We6nrvSOgh89N60JT3d7HRWpn3TvYWLse3X0KSmib1It1uidtzNMIdcUWgskMkblUdYxXnXhK6EjffKt06lw7MKY9WqE7XaJpIDpD2soe1hxUWbaeV3H_vHpnTOserf3MvGo0JL86ohxlIWSC3lWJ67RJVKOWvSBAIt-W3E6_alDbh4jKJNZT0TPe6C3QORYmDOhq6oq3o/p.png",
          title: "Photography",
        },
      ],
    };
  },
};
</script>

<style scoped>
#services .container {
  min-height: 40vh;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: rgba(245, 246, 251, 255);
}
/* Card CSS */
.service-top h3 {
  color: rgba(50, 50, 50, 255);
  font-family: "Roboto Slab", serif;
  font-weight: bold;
  font-size: 35px;
  text-align: center;
  padding-top: 5rem;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-color: rgba(196, 234, 230, 255);
  text-decoration-thickness: 5px;
  text-decoration-skip-ink: none;
}
#services .services {
  flex-direction: column;
  max-width: 100vw;
  min-height: 90vh;
}
#services .service-top {
  max-width: 500px;
  margin: 0 auto;
}
#services .service-bottom {
  display: flex;
  flex-wrap: wrap;
  margin-top: 50px;
}
.service-logo {
  margin-bottom: 2rem;
  align-items: center;
}
h5 {
  color: rgba(50, 50, 50, 255);
  font-family: "Roboto Slab", serif;
  font-weight: bold;
  padding-bottom: 1rem;
}
p {
  font-family: "PT Sans";
  color: rgba(112, 112, 112, 255);
}
.service-col {
  margin-bottom: 1rem;
}
#services .card-body {
  min-width: 15rem;
  min-height: 20rem;
  padding: 3rem;
}
/*  Container of 6 cards CSS */
.kind-container {
  margin-bottom: 5rem;
}
</style>
